var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fade-in"},[_c('Camera',{attrs:{"headerText":"Tire a foto da frente do seu documento (sem plástico)","onBackGoTo":"onboarding-frontdoc-step"},on:{"sendImg":_vm.handleImg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }